<div class="container">
    <h2>Confirm Upload and Apply</h2>
    <p>Are you sure you want to upload the file {{fileName}}</p>
    <div class="buttons">
        <button mat-raised-button (click)="closeDialog(true)"><mat-icon>save</mat-icon>Create</button>
        <button mat-raised-button (click)="closeDialog(false)">Cancel</button>
    </div>
</div>